import { render, staticRenderFns } from "./AmetrasAdvancedButtonTemplate.vue?vue&type=template&id=5ff62f86&scoped=true&"
import script from "./AmetrasAdvancedButtonTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasAdvancedButtonTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasAdvancedButtonTemplate.vue?vue&type=style&index=0&id=5ff62f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff62f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
